/** Timeline entities for codes scanned at a stop, by the stop's name. */
export const SCAN_ENTITY_STOPS: Record<string, string> = {
  dropoffScan: "drop-off",
  pickupScan: "pickup",
};

/** Timeline entities for codes added to, changed on or removed from a stop. */
export const CODE_ENTITY_STOPS: Record<string, string> = {
  dropoffCode: "drop-off",
  pickupCode: "pickup",
};
